import { Api } from "api";

const endpoint = "/mobile_client_versions/v1/admin/";

export const getVersions = async (page?: number) => {
  const res = await Api.get(endpoint, {
    params: {
      page: page,
      sort: 'DESC',
    },
  });
  return res.data;
};

export const addVersion = async (payload: any) => {
  const res = await Api.post(endpoint, payload);
  return res.data;
};

export const editVersion = async (id: string, payload: any) => {
  const res = await Api.put(endpoint + id, payload);
  return res.data;
};

export const deleteVersion = async (id: string) => {
  const res = await Api.delete(endpoint + id);
  return res.data;
};
